module.exports = __webpack_public_path__ + "static/media/banner_01.f98a7c04.webp";